import React, { useState } from 'react';
import css from './CostSummaryHeaderStep3.module.css';
import { ViewItemTypesModeType } from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import ViewModeSwitcher from '@modules/Steps/Shared/Widgets/ViewModeSwitcher/ViewModeSwitcher';
import CircularArrowsIcon from '@shared/Icons/CircularArrowsIcon';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { CustomProjectStep3ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep3ElementsIdsEnum';
import { ItemsSelectionViewModel } from '@viewModels/ItemsSelectionViewModel/ItemsSelectionViewModel';

interface CostSummaryHeaderStep3Props {
    viewMode: ViewItemTypesModeType;
}

export const CostSummaryHeaderStep3: React.FC<CostSummaryHeaderStep3Props> = ({
    viewMode,
}) => {
    const selectedItemsViewModel = new ItemsSelectionViewModel();

    const [clearSelectionAnimation, setClearSelectionAnimation] =
        useState(false);

    const handleSelectAllInTemplate = () => {
        selectedItemsViewModel.selectAllItems();
    };

    const handleClearSelection = () => {
        selectedItemsViewModel.clearAllSelectedItems();
        setClearSelectionAnimation(true);
        setTimeout(() => setClearSelectionAnimation(false), 300);
    };

    return (
        <div className={css.costSummaryHeaderWrapper}>
            <p className={css.costSummary}>Cost summary</p>

            <div className={css.costSummarySwitcher}>
                <ViewModeSwitcher viewMode={viewMode} />
            </div>

            <div className={css.costSummaryBtns}>
                <BasicButton
                    onClick={handleSelectAllInTemplate}
                    extraClassName={css.selectAllBtn}
                    id={
                        CustomProjectStep3ElementsIdsEnum.WORK_AREA_STEP3_SELECT_ALL_TEMPLATE_BUTTON
                    }
                >
                    Select all in template
                </BasicButton>

                <BasicButton
                    onClick={handleClearSelection}
                    extraClassName={css.clearSelectionBtn}
                    id={
                        CustomProjectStep3ElementsIdsEnum.WORK_AREA_STEP3_CLEAR_ALL_TEMPLATE_BUTTON
                    }
                    children={
                        <>
                            <CircularArrowsIcon
                                height={18}
                                width={18}
                                fill="currentColor"
                                className={
                                    clearSelectionAnimation
                                        ? css.rotatedBtnIcon
                                        : css.btnIcon
                                }
                            />
                            Clear selection
                        </>
                    }
                />
            </div>
        </div>
    );
};
